<div class="row px-1">
  <div class="only-button d-flex justify-content-end container-style px-2 py-1">
    <app-custom-button class="button-new-register" [width]="'5rem'" [title]="'Nuevo'" [label]="'Nuevo'"
      [icon]="'pi pi-plus'" [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
      (onClick)="newUser()"></app-custom-button>
  </div>
</div>
<div class="container-style mt-2">
  <app-custom-table [showExport]="true" [showRecover]="true" [headers]="header" [data]="data" [actions]="tableActions"
    [previousFilters]="filters" [filterPersistentKey]="'profileUser'" (onRecoverData)="getProfileUsersWithPagination()"
    (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)" (onExport)="exportConsultation()"
    (onAction)="onAction($event)">
  </app-custom-table>
</div>